<template>
  <div>
    <Loading
      v-if="isLoading"
      loading-message="載入中..."
      :background-color="'#ffffff'"
    />

    <img
      class="banner-image w-100"
      v-if="deepGet(form, 'config.content_page.banner_image')"
      :src="deepGet(form, 'config.content_page.banner_image')"
    />

    <div class="page">
      <div
        v-if="deepGet(form, 'config.content_page.form_title')"
        class="page__title"
      >
        {{ deepGet(form, 'config.content_page.form_title') }}
      </div>
      <div v-if="deepGet(form, 'config.content_page.form_desc')" class="page__desc">
        {{ deepGet(form, 'config.content_page.form_desc') }}
      </div>
      <div
        v-if="deepGet(form, 'config.content_page.content')"
        v-html="deepGet(form, 'config.content_page.content')"
        class="page__content"
      ></div>

      <DynamicForm
        ref="dynamicForm"
        class="my-4 mx-2"
        :input-subjects="dynamicFormFields"
        v-model="inputForm"
      ></DynamicForm>

      <SharedButton class="s-btn-bg-primary" @click="submitForm">
        {{ deepGet(form, 'config.content_page.button_text', '送出') }}
      </SharedButton>

      <div
        v-if="deepGet(form, 'terms')"
        v-html="deepGet(form, 'terms')"
        class="mt-3 p-3"
      ></div>
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import { mapState } from "vuex";
import formApi from "@/apis/liff/v2/form";
import DynamicForm from "@/components/DynamicForm/DynamicForm.vue";
import SharedButton from "@/components/Page/Liff/Shared/Button";
import Loading from "@/components/Page/Liff/Shared/Loading";
import DynamicFormField from "@/models/DynamicFormField.model"
import Form from "@/models/Form.model"

export default {
  components: {
    DynamicForm,
    SharedButton,
    Loading,
  },
  computed: {
    ...mapState({
      user: (state) => state.liffAuth.user,
    }),
    formDataModel() {
      return new Form(this.form)
    },
    dynamicFormFields() {
      return _.get(this.form, 'subjects', []).map(subject => ({
        ...(new DynamicFormField(subject)).flattenedAttributes(),
        dbPrimaryKey: subject.id,
      }))
    },
    payloadForSubmission() {
      return this.dynamicFormFields.map(fieldAttributes => ({
        subject_id: fieldAttributes.dbPrimaryKey,
        value: this.inputForm[fieldAttributes._id] ?? null,
      }))
    },
  },
  data() {
    return {
      inputForm: {},
      form: {},
      isLoading: true,
    };
  },
  async mounted() {
    await this.fetchForm()

    if (this.formDataModel.requireCustomerRegistration() && !this.user.registered_at) {
      this.$router.push({ name: "LiffRegisterIndex" })
    }

    if (false === this.formDataModel.isPublicAccessibleToCustomers()) {
      this.$router.replace({ name: "LiffFormIndex", params: { form_id: this.form.id } })
    }

    this.dynamicFormFields.forEach(fieldModel => {
      if (fieldModel.assign_to_customer_data && [null, undefined].includes(this.inputForm[fieldModel._id])) {
        this.$set(this.inputForm, fieldModel._id, _.get(this.user, fieldModel.assign_to_customer_data))
      }
    })

    this.isLoading = false
  },
  methods: {
    deepGet: _.get,
    async fetchForm() {
      try {
        this.form = _.get(await formApi.getForm(this.$route.params.form_id, {}), 'data.data')
      } catch (error) {
        if (error.response.status === 404) {
          this.$swal("錯誤", "找不到此問券", "error");
        } else {
          console.error(error);
          this.$swal("錯誤", "", "error");
        }
      }
    },
    async submitForm() {
      const validate = await this.$refs.dynamicForm.validate();

      if (!validate) return;

      try {
        this.isLoading = true;

        const result = await formApi.saveResult(this.form.id, { answers: this.payloadForSubmission })

        this.$router.push({
          name: this.formDataModel.routeNameAfterSubmission(),
          query: {
            form_result_id: result.data.data.result_id
          }
        });
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "送出問券時發生問題，請稍候再試", "error");
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.form-title {
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  margin-top: 12px;
  margin-bottom: 12px;
}
</style>
